module.exports = __webpack_public_path__ + "img/liushui (7).e077ba2d.png";